import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { useUserStore } from "./store/index";
import { loadFonts } from "./plugins/webfontloader";
import axios from "axios";
import { createPinia } from "pinia";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import functions from "./plugins/functions";

import "./assets/font-sizes.css";
import "./assets/styling.css";

const app = createApp(App);
const pinia = createPinia();
app.use(functions);
app.use(pinia);
app.component("QuillEditor", QuillEditor);

const userStore = useUserStore(pinia);

axios
  .post("/api/authorization/check")
  .then((response) => {
    if (response.data.success) {
      const {
        id, firstname, lastname, email, state, position,
        isTechnicalReviewer, isVisualReviewer, permissions,
      } = response.data.user.user;
      const userData = {
        id,
        firstname,
        lastname,
        email,
        state,
        position,
        isTechnicalReviewer: isTechnicalReviewer || 0,
        isVisualReviewer: isVisualReviewer || 0,
        permissions: permissions || {},
      };
      userStore.setUser(userData);
    }
  })
  .catch((error) => {
    console.error("Fehler beim Überprüfen des Logins: ", error);
  });

app.mixin({
  computed: {
    $user() {
      return useUserStore().user;
    },
  },
  methods: {
    /** $can('sections.edit') – reaktiv, da useUserStore() aufgelöst wird. */
    $can(key) {
      const perms = useUserStore().user?.permissions || {};
      return perms[key] === 1 || perms[key] === true;
    },
  },
});

loadFonts();

app.use(router).use(vuetify).mount("#app");
